import type {
  LeadFlowSectionTheme,
  LeadFlowStepTheme,
  LeadFlowThemeContrast,
} from "../types";

import {
  getThemeContrast,
  UNPAINTED_SURFACE,
} from "@homeinstead/tailwind-config/section-surfaces";

/**
 * The text contrast a step's colour-dependent styles follow. An `inherit`
 * step takes the section's theme, and an unthemed section sits on the
 * unpainted page surface.
 */
function getStepThemeContrast(
  stepTheme: LeadFlowStepTheme | undefined,
  sectionTheme: LeadFlowSectionTheme | undefined,
): LeadFlowThemeContrast {
  const theme =
    stepTheme === "inherit" || !stepTheme ? sectionTheme : stepTheme;

  return getThemeContrast(theme) ?? UNPAINTED_SURFACE.contrast;
}

export { getStepThemeContrast };
